var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProviders(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.04165 4.99999C6.04165 4.65481 6.32147 4.37499 6.66665 4.37499L16.6667 4.37499C17.0118 4.37499 17.2917 4.65481 17.2917 4.99999C17.2917 5.34516 17.0118 5.62499 16.6667 5.62499L6.66665 5.62499C6.32147 5.62499 6.04165 5.34516 6.04165 4.99999Z",
    fill: "#4B5054"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.75975 4.5345C4.01632 4.76541 4.03712 5.16059 3.80621 5.41716L3.79788 5.42642C3.56696 5.68299 3.17178 5.70379 2.91522 5.47288C2.65865 5.24197 2.63785 4.84678 2.86876 4.59022L2.87709 4.58096C3.10801 4.32439 3.50319 4.30359 3.75975 4.5345Z",
    fill: "#4B5054"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.75975 9.5345C4.01632 9.76541 4.03712 10.1606 3.80621 10.4172L3.79788 10.4264C3.56696 10.683 3.17178 10.7038 2.91522 10.4729C2.65865 10.242 2.63785 9.84678 2.86876 9.59022L2.87709 9.58096C3.10801 9.32439 3.50319 9.30359 3.75975 9.5345Z",
    fill: "#4B5054"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.75975 14.5345C4.01632 14.7654 4.03712 15.1606 3.80621 15.4172L3.79788 15.4264C3.56696 15.683 3.17178 15.7038 2.91522 15.4729C2.65865 15.242 2.63785 14.8468 2.86876 14.5902L2.87709 14.581C3.10801 14.3244 3.50319 14.3036 3.75975 14.5345Z",
    fill: "#4B5054"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.04165 9.99999C6.04165 9.65481 6.32147 9.37499 6.66665 9.37499L16.6667 9.37499C17.0118 9.37499 17.2917 9.65481 17.2917 9.99999C17.2917 10.3452 17.0118 10.625 16.6667 10.625L6.66665 10.625C6.32147 10.625 6.04165 10.3452 6.04165 9.99999Z",
    fill: "#4B5054"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.04165 15C6.04165 14.6548 6.32147 14.375 6.66665 14.375L16.6667 14.375C17.0118 14.375 17.2917 14.6548 17.2917 15C17.2917 15.3452 17.0118 15.625 16.6667 15.625L6.66665 15.625C6.32147 15.625 6.04165 15.3452 6.04165 15Z",
    fill: "#4B5054"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProviders);
export default __webpack_public_path__ + "static/media/providers.4fd7d847555259e69387dab7f81ce53e.svg";
export { ForwardRef as ReactComponent };